export default {
    setCurrentSiteSettings(state,payload){
        state.siteSettings = payload;
    },
}